module.exports = __webpack_public_path__ + "assets/img/cfsb.28f6ccac.png";